import { ApiService } from "@/services/api/ApiService";
import { DefaultPronunciationsPreview, PronunciationChange, PronunciationVault, PronunciationVaultInput } from "@/types/agent/pronunciation-vault";

export class PronunciationVaultService {
  static async list(): Promise<PronunciationVault[]> {
    const response = await ApiService.invoke<{ vaults: PronunciationVault[] }>({
      resource: "pronunciation-vaults",
      action: "all",
    });
    return response.vaults ?? [];
  }

  static async get(id: string): Promise<PronunciationVault> {
    const response = await ApiService.invoke<{ vault: PronunciationVault }>({
      resource: "pronunciation-vaults",
      action: "get",
      id,
    });
    return response.vault;
  }

  static async create(input: PronunciationVaultInput): Promise<PronunciationVault> {
    const response = await ApiService.invoke<{ vault: PronunciationVault }>({
      resource: "pronunciation-vaults",
      action: "create",
      data: input,
    });
    return response.vault;
  }

  static async update(id: string, input: Partial<PronunciationVaultInput>): Promise<PronunciationVault> {
    const response = await ApiService.invoke<{ vault: PronunciationVault }>({
      resource: "pronunciation-vaults",
      action: "update",
      id,
      data: input,
    });
    return response.vault;
  }

  static async delete(id: string): Promise<void> {
    await ApiService.invoke({
      resource: "pronunciation-vaults",
      action: "delete",
      id,
    });
  }

  static async previewDefaults(): Promise<DefaultPronunciationsPreview> {
    const data = await ApiService.callEdge("handle-agent", {
      action: "apply-default-pronunciations",
      preview: true,
    });
    if (!data?.success) {
      throw new Error(data?.message || data?.error || "Failed to load default pronunciations");
    }
    return { genieCount: data.genieCount, words: data.words };
  }

  static async applyDefaults(): Promise<{ jobId: number; genieCount: number }> {
    const data = await ApiService.callEdge("handle-agent", { action: "apply-default-pronunciations" });
    if (!data?.success) {
      throw new Error(data?.message || data?.error || "Failed to apply default pronunciations");
    }
    return { jobId: data.jobId, genieCount: data.genieCount };
  }

  static async updateDefaults(changes: PronunciationChange[]): Promise<{ jobId: number; genieCount: number }> {
    const data = await ApiService.callEdge("handle-agent", { action: "update-default-pronunciations", changes });
    if (!data?.success) {
      throw new Error(data?.message || data?.error || "Failed to update default pronunciations");
    }
    return { jobId: data.jobId, genieCount: data.genieCount };
  }
}
